import { useState, useLayoutEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { SERVER_URL } from "../../util/url";

import Navbar from "./navbar/navbar";
import Bottombar from "./bottombar/bottombar";
import Dashboard from "../dashboard/dashboard";
import Recipeslist from "../recipeslist/recipeslist";
import Recipe from "../recipe/recipe";
import Orderslist from "../orderslist/orderslist";
import NewRecipe from "../new_recipe/new_recipe";
import ModifiedRecipe from "../modified_recipe/modified_recipe";

import "./homepage.css";

function Homepage() {
    const location = useLocation();
    const [selectedPage, setSelectedPage] = useState(location.pathname.substring(10));
    const [plants, setPlants] = useState([]);
    const [selectedPlant, setSelectedPlant] = useState("--");
    const [recipeParameters, setRecipeParameters] = useState("");
    const [orderParameters, setOrderParameters] = useState("");

    useLayoutEffect(() => {
        
        const controller = new AbortController();
        const signal = controller.signal;

        fetchPlants(signal);

        return () => {
            controller.abort();
        };

    }, []);

    const fetchPlants = (signal) => {
        fetch(SERVER_URL + "/plants", { signal })
            .then((res) => res.json())
            .then((data) => {
                setPlants(data.data);
                setSelectedPlant(data.data[0].name);
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
    };

    return (
        <div className="homepage">
            <Navbar plants={plants} selectedPlant={selectedPlant} setPlant={setSelectedPlant} />
            <Bottombar page={selectedPage} setPage={setSelectedPage}/>
            <Routes>
                <Route path="dashboard" element={<Dashboard plant={selectedPlant} setPage={setSelectedPage} setOrderParameters={setOrderParameters} setRecipeParameters={setRecipeParameters} />} />
                <Route path="orderslist" element={<Orderslist plant={selectedPlant} parameters={orderParameters} setOrderParameters={setOrderParameters} />} />
                <Route path="recipeslist" element={<Recipeslist plant={selectedPlant} parameters={recipeParameters} setRecipeParameters={setRecipeParameters} />} />
                <Route path="recipeslist/:id" element={<Recipe  />} />
                <Route path="recipeslist/modified/:id" element={<ModifiedRecipe />} />
                <Route path="recipeslist/new/:id" element={<NewRecipe />} />
            </Routes>
        </div>
    );
}

export default Homepage;
